//单个页面
import Home from "../pages/Home/Index.vue";
//添加设备
import DeviceList from "../pages/connect/DeviceList.vue";
//wifi设备入网
import TurnOnController from "../pages/connect/wifi/TurnOn.vue";
import TipsOfConnect from "../pages/connect/wifi/TipsOfConnect.vue";
import ConnectStart from "../pages/connect/wifi/ConnectStart.vue";
import ConnectWifi from "../pages/connect/wifi/ConnectWifi.vue";
import BindController from "../pages/connect/wifi/BindController.vue";
import Done from "../pages/connect/wifi/Done.vue";
import SelectRoom from "../pages/connect/wifi/SelectRoom.vue";
//zigbee设备入网
import HubTurnOn from "../pages/connect/zigbee/TurnOn.vue";
import Hub_list from "../pages/connect/zigbee/Hub_list.vue";
import Hub_listNotFound from "../pages/connect/zigbee/Hub_listNotFound.vue";
import Hub_listAdded from "../pages/connect/zigbee/Hub_listAdded.vue";
import Hub_addRemote from "../pages/connect/zigbee/Hub_addRemote.vue";
import ZigBeeScan from "../pages/connect/zigbee/Scan.vue";

// 频道
import ChannelAdd from "../pages/settings/channel/ChannelAdd.vue";
import ChannelList from "../pages/settings/channel/ChannelList.vue";
import ChannelSelect from "../pages/settings/channel/ChannelSelect.vue";
//使用说明
import Tutorial from "../pages/Tutorial/Index.vue";
//联系客服
import ContactUs from "../pages/ContactUs/Index.vue";
//设备详情-小方
import Settings from "../pages/settings/Index.vue";
//设备
import Tv from "../pages/device/tv/Index.vue";
import TvBox from "../pages/device/tvBox/Index.vue";
import XiaoFang from "../pages/device/xiaofang/Index.vue";
import XiaoFangTips from "../pages/device/xiaofang/Tips/Index.vue";
import Fan from "../pages/device/fan/Index.vue";
import Air from "../pages/device/air/Index.vue";

import TvBrandList from "../pages/device/tv/BrandList.vue";
import FanBrandList from "../pages/device/tv/BrandList.vue";
import AirBrandList from "../pages/device/tv/BrandList.vue";
import TvBoxBrandList from "../pages/device/tvBox/BrandList.vue";
import IPTVBrandList from "../pages/device/tvBox/IptvList.vue";
/**要求后端增加一个根路径做映射。
 *
 */
export const routes = [
  /**/
  { path: "/index.html", redirect: "/" },
  { path: "/index.html", redirect: "/" },
  /*首页 */
  { path: "/", component: Home },

  /*添加控制器*/
  { path: "/connect/device_list", component: DeviceList },

  //wifi类入网
  { path: "/connect/wifi/turn_on", component: TurnOnController },
  { path: "/connect/wifi/tips", component: TipsOfConnect },
  { path: "/connect/wifi/start", component: ConnectStart },
  { path: "/connect/wifi/wifi", component: ConnectWifi },
  { path: "/connect/wifi/bind", component: BindController },
  { path: "/connect/wifi/done", component: Done },
  { path: "/connect/wifi/select_room", component: SelectRoom },

  //zigbee类入网
  { path: "/connect/zigbee/turn_on", component: HubTurnOn },
  { path: "/connect/zigbee/hub_list", component: Hub_list },
  { path: "/connect/zigbee/hub_list_not_found", component: Hub_listNotFound },
  { path: "/connect/zigbee/hub_list_added", component: Hub_listAdded },
  { path: "/connect/zigbee/hub_add_remote", component: Hub_addRemote },
  { path: "/connect/zigbee/scan", component: ZigBeeScan },

  /*小方*/
  { path: "/device/xiaofang", component: XiaoFang },
  { path: "/device/xiaofang/tips", component: XiaoFangTips },

  /*wifi遥控指引*/
  { path: "/tutorial", component: Tutorial },

  /*电视*/
  { path: "/device/tv", component: Tv },
  { path: "/device/tv/add", component: TvBrandList },

  /*机顶盒*/
  { path: "/device/tvbox", component: TvBox },
  { path: "/device/tvbox/add", component: TvBoxBrandList },
  { path: "/device/tvbox/iptv_list", component: IPTVBrandList },

  // { path: "/device/tvbox/add", component: TvBoxBrandList },
  // { path: "/device/tvbox/iptv_list", component: IPTVBrandList },

  /*风扇*/
  { path: "/device/fan", component: Fan },
  { path: "/device/fan/add", component: FanBrandList },

  /* 空调 */
  { path: "/device/air", component: Air },
  { path: "/device/air/add", component: AirBrandList },

  /*设备设置*/
  { path: "/settings", component: Settings },
  /*频道*/
  { path: "/settings/channel/add", component: ChannelAdd },
  { path: "/settings/channel/list", component: ChannelList },
  { path: "/settings/channel/select", component: ChannelSelect },
  /*联系我们*/
  { path: "/contact", component: ContactUs }
];



// WEBPACK FOOTER //
// ./src/router/index.js